import styled from 'styled-components';

export const TableHeader = styled.h5`
  margin: 1.5rem 0 1rem;
  width: 100%;
  font-size: 1rem;
  font-weight: ${Styles.fontWeight.heavy};
  border-bottom: 1px solid ${Styles.color.grey.five};
`;
